import { render, staticRenderFns } from "./ScoreThresholdBadge.vue?vue&type=template&id=c27bf114"
import script from "./ScoreThresholdBadge.vue?vue&type=script&lang=js"
export * from "./ScoreThresholdBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports